module.exports = __webpack_public_path__ + "20456cb67105b3eca8394062156fe022.svg";